import React, { useEffect, useRef, useState } from "react";
import "./search-plots.css";
import { TPlot } from "stencil-library";
import { fetchUserPlots } from "../../services/user.service";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { selectedPlotState } from "../../state/atoms/global.atom";
import { languageAtom } from "../../state/atoms/language.atom";
import { PlotCard, SearchBar } from "./component";
import { SearchBarHandle } from "./component/SearchBar";
import { ScreenHeader } from "react-library";
import { useNavigate, useParams } from "react-router-dom";
import { Routes } from "../../routes";
import { t } from "../../services/locale.service";

function SearchPlotsScreen() {
  const navigate = useNavigate();
  const { orgId } = useParams();
  const setSelectedPlot = useSetRecoilState(selectedPlotState);
  const selectedLanguage = useRecoilValue(languageAtom);

  const searchBarRef = useRef<SearchBarHandle>(null);

  const [isUserSearchingStatus, setIsUserSearchingStatus] =
    useState<boolean>(false);
  const [allUserPlots, setAllUserPlots] = useState<Array<TPlot>>([]);
  const [searchedPlots, setSearchedPlots] = useState<Array<TPlot>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSearching, setIsSearching] = useState<boolean>(false);

  const screenName = t("Search_Your_Plot");

  const clearSearch = () => {
    if (searchBarRef.current) {
      searchBarRef.current.clearInput();
    }
  };

  const searchPlot = async (searchText = "") => {
    if (!searchText || (searchText.length === 0 && !isLoading)) {
      return;
    }

    // if(searchText.length < 3) {
    //   return;
    // }

    try {
      setIsSearching(true);
      const searchedPlots = await fetchUserPlots(
        { searchText },
        { skip: 0, limit: 20 }
      );

      setSearchedPlots(searchedPlots);
    } catch (error) {
      console.error("search plot", error);
    } finally {
      setIsSearching(false);
    }
  };

  const onPlotSelect = (plot: TPlot) => {
    try {
      setSelectedPlot(plot);
      clearSearch();
      navigate(Routes.orgHome.replace(":orgId", orgId!));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPlots = async () => {
    try {
      setIsLoading(true);
      const plots = await fetchUserPlots({});
      setAllUserPlots(plots);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    try {
      window.history.back();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  useEffect(() => {
    fetchPlots();
  }, []);

  return (
    <div className="container">
      <ScreenHeader screenName={screenName} />
      <div className={"searchContainer"}>
        <SearchBar
          ref={searchBarRef}
          placeholder={t("Find_your_plot")}
          onTextChange={searchPlot}
          userSearchingStatus={(status) => setIsUserSearchingStatus(status)}
        />
        <div className="searchResults">
          {isUserSearchingStatus ? (
            isSearching ? (
              <div className="searchResultsLoadingContainer">
                <p className="searchResultsLoading">{t("Finding_Your_Plot")}</p>
              </div>
            ) : (
              searchedPlots?.map((plot, index) => (
                <>
                  <PlotCard
                    onPlotSelect={onPlotSelect}
                    lang={selectedLanguage}
                    key={`plot-card-${index}-${plot.plotId}`}
                    plot={plot}
                  />
                  {index != allUserPlots?.length - 1 ? (
                    <div className="divider" />
                  ) : (
                    <div></div>
                  )}
                </>
              ))
            )
          ) : isLoading ? (
            <div
              style={{ overflowX: "hidden", padding: 10, textAlign: "center" }}
            >
              {t("Loading")}
            </div>
          ) : (
            allUserPlots?.map((plot, index) => (
              <>
                <PlotCard
                  onPlotSelect={onPlotSelect}
                  lang={selectedLanguage}
                  key={`plot-card-${index}-${plot.plotId}`}
                  plot={plot}
                />
                {index != allUserPlots?.length - 1 ? (
                  <div className="divider" />
                ) : (
                  <div></div>
                )}
              </>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchPlotsScreen;